import platformServicesClient from '@backend-clients/platform-services';

export default {
  get: (projectId) => platformServicesClient.get(`/api/v1/projects/${projectId}/missions`),
  getStatus: (projectId, missionId) => platformServicesClient.get(`/api/v1/projects/${projectId}/missions/${missionId}/statuses`),
  ingestMedia: (data) => platformServicesClient.post('/api/v1/integrations/ingest/nypa', data),
  triggerAiProcessing: (projectId, missionId) => platformServicesClient.post(`/api/v1/integrations/projects/${projectId}/missions/${missionId}/process/status`),
  pushToMediaHub: (projectId, missionId) => platformServicesClient.post(`/api/v1/integrations/projects/${projectId}/export_mission/nypa`, { missionId }),
};
